<script>
  import Spacing from "../components/Spacing/Spacing.svelte";
  import AppText from "../components/Text/AppText.svelte";
  import HeaderText from "../components/Text/HeaderText.svelte";
  import AppInput from "../components/Form/Input.svelte";
  import Select from "svelte-select";
  import AppDot from "../components/Dot/AppDot.svelte";
  import UserCard from "../components/Card/UserCard.svelte";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import API from "../utils/api";
  import LayoutContent from "../components/Layout/LayoutContent.svelte";
  import State from "../utils/functions/State";

  let loading = true;
  let data = [];
  let filteredData = [];
  let filter = "";
  let allStates = [
    {
      value: "unconfirmed",
      label: "Non confirmé",
    },
    {
      value: "confirmed",
      label: "Confirmé",
    },
    {
      value: "validated",
      label: "Validé",
    },
    {
      value: "blacklisted",
      label: "Suspendu",
    },
  ];
  let state = null;
  $: {
    filteredData = data;
    if (filter.trim().length) {
      let filters = filter
        .split(" ")
        .filter((e) => e.length)
        .map((e) => e.toLowerCase());
      filteredData = data.filter((a) => {
        const str =
          `${a.firstName} ${a.lastName} ${a.email} ${a.company}`.toLowerCase();
        return filters.every((f) => str.indexOf(f) > -1);
      });
    }
    if (state) {
      if (state == "unconfirmed") {
        filteredData = filteredData.filter((a) => !a.confirmed && !a.validated);
      } else if (state == "confirmed") {
        filteredData = filteredData.filter((a) => a.confirmed && !a.validated);
      } else if (state == "validated") {
        filteredData = filteredData.filter(
          (a) => a.validated && !a.blacklisted
        );
      } else if (state == "blacklisted") {
        filteredData = filteredData.filter((a) => a.blacklisted);
      }
    }
  }

  const getSubsribers = async (callback) => {
    try {
      const response = await API.get("admin/subscriber");
      callback(response);
      loading = false;
    } catch (e) {
      console.error(e);
    }
  };
  onMount(() => {
    getSubsribers((r) => {
      data = r.subscribers;
      // console.log(
      //   data.filter((el) => el.subscriptions.find((e) => e.clubDeal === null))
      // );
    });
  });
  const username = (...args) => {
    return [...args].filter((el) => el).join(" ");
  };
  const color = (el) => {
    return el === 0 ? "disabled" : "primary";
  };
</script>

<span>
  <HeaderText>Participants</HeaderText>
</span>

<div id="filters">
  <section>
    <AppInput
      label="Filtre (prénom, nom, email, société)"
      bind:value={filter}
      crop
      placeholder="Prénom, nom, email, société"
      autofocus={true}
    />
  </section>
  <section>
    <AppText weight="bold">Etat :</AppText>
    <Spacing y="6" />
    <div class="themed">
      <Select
        items={allStates}
        isMulti={false}
        placeholder="Aucun état sélectionné"
        on:select={(e) => (state = e.detail.value)}
        on:clear={() => (state = null)}
      />
    </div>
  </section>
</div>

<LayoutContent {loading}>
  {#each filteredData as subscriber}
    <section>
      <UserCard
        on:click={() => navigate(`/participants/${subscriber.id}`)}
        badge={State.subscriber(subscriber)}
        company={subscriber.company}
        username={username(subscriber.firstName, subscriber.lastName)}
      >
        <AppText size="small">nombre de souscriptions</AppText>
        <AppDot color={color(subscriber.subscriptions.length)}>
          {subscriber.subscriptions.length}
        </AppDot>
      </UserCard>
    </section>
  {/each}
  <section />
  <section />
  <section />
</LayoutContent>

<style>
  span {
    display: block;
    @include respond-to("md") {
      display: none;
    }
  }
  section {
    width: 100%;
    @include respond-to("md") {
      width: calc(50% - 8px);
    }
    @include respond-to("lg") {
      width: calc(33% - 8px);
    }
    @include respond-to("xl") {
      width: 340px;
    }
  }
  div#filters {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: flex-start;
    border-bottom: 1px solid $gray;
    section {
      margin-bottom: 8px;
    }
    padding-bottom: 8px;
    margin-bottom: 16px;
  }
</style>
